'use client';

import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

type Props = {
  isOpen: boolean;
  selectedText: string;
  onClose: () => void;
  onApply: (params: { correctedText: string }) => Promise<void>;
};

export default function TranscriptionCorrectionModal({ isOpen, selectedText, onClose, onApply }: Props) {
  const [corrected, setCorrected] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setCorrected('');
    }
  }, [isOpen, selectedText]);

  const handleApply = async () => {
    setSubmitting(true);
    try {
      await onApply({ correctedText: corrected.trim() });
      onClose();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[560px]">
        <DialogHeader>
          <DialogTitle>文字起こし修正</DialogTitle>
          <DialogDescription>選択した誤認識を修正し、辞書に自動追加します。</DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <div className="text-sm text-gray-600 mb-1">選択されたテキスト</div>
            <Input value={selectedText} readOnly className="font-mono" aria-label="選択テキスト" />
          </div>
          <div>
            <div className="text-sm text-gray-600 mb-1">正しい表記</div>
            <Input
              placeholder="正しい表記を入力..."
              value={corrected}
              onChange={(e) => setCorrected(e.target.value)}
            />
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={onClose} disabled={submitting}>キャンセル</Button>
            <Button onClick={handleApply} disabled={submitting || !selectedText || !corrected.trim()}>
              {submitting ? '適用中...' : '修正を適用'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}



